import { Component, OnInit } from '@angular/core';
import {LocalStorageSettingsService} from '../../shared/services/local-storage-settings.service';
import {CommonService} from '../../shared/services/common.service';
import {ReportlinksserviceService} from '../reportlinks/reportlinksservice.service';
import {Messages} from '../../shared/Validations/messages';
import {Router} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {constants} from '../../shared/common/contants';
import {DataLoadingService} from '../../shared/services/data-loading.service';
import {
  IncrementalDataLoadSchedulePopupComponent
} from '../baseline-data-load/incremental-data-load-schedule-popup/incremental-data-load-schedule-popup.component';
import {FiledownloadComponent} from '../../shared/common/filedownload.component';
import {ActionCheckBox} from '../../shared/common/ActionCheckBox';
import {EtlService} from '../vault-data-migration-etl/etl.service';

@Component({
    selector: 'app-incremental-data-load',
    templateUrl: './incremental-data-load.component.html',
    styleUrls: ['./incremental-data-load.component.scss'],
    standalone: false
})
export class IncrementalDataLoadComponent implements OnInit {
  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  pageSize;

  rowClassRules;

  defaultColDef;

  columnDefs;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  components: any;

  gridColumnAPI


  getdata: any;
  validation_messages:any;
  backgroundColorScreen = "";
  backgroundColorButton = "";
  onGridReadyParams

      constructor( private localStorageSettings: LocalStorageSettingsService,
                   private dataLoadService: DataLoadingService,
                   private constants: constants,
                   private snackbar: MatSnackBar,
                   private msg: Messages,
                   private spinner: NgxUiLoaderService,
                   private dialog: MatDialog,
                   private etlService:EtlService) {
        this.components = {
          downloadbuttonRenderer: FiledownloadComponent,
        }

      }

  ngOnInit(): void {

    this.columnDefs = [
      { headerName: 'Incremental History Id',
        headerTooltip: 'Incremental History Id',
        tooltipValueGetter: (params) => 'Incremental History Id : ' + params.value,
        field: 'id',
        filter: 'agTextColumnFilter',
        width: 100
      },
      { headerName: 'Schedule Id',
        headerTooltip: 'Schedule Id',
        tooltipValueGetter: (params) => 'Schedule Id : ' + params.value,
        field: 'scheduleid',
        filter: 'agTextColumnFilter',
        width: 100
      },
      { headerName: 'Last Extraction Date Time',
        headerTooltip: 'Last Extraction Date Time',
        tooltipValueGetter: (params) => 'Last Extraction Date Time : ' + params.value,
        field: 'extractiondateTime',
        filter: 'agTextColumnFilter',
        width: 180
      },

      { headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'status',
        filter: 'agTextColumnFilter',
        width: 180
      },
      { headerName: 'Extraction Log',
        headerTooltip: 'Extraction Log',
        tooltipValueGetter: (params) => 'Extraction Log : ' + params.value,
        cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.downloadExtractionLog.bind(this),

        },
        field: 'extractionlog',
        filter: 'agTextColumnFilter',
        width: 180
      },
      // {
      //   headerName: 'Created By',
      //   headerTooltip: 'Created By',
      //   tooltipValueGetter: (params) =>
      //     'Created By : ' + params.value,
      //   field: 'createdBy',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // },
      //
      // {
      //   headerName: 'Created Date',
      //   headerTooltip: 'Created Date',
      //   tooltipValueGetter: (params) =>
      //     'Created Date : ' + params.value,
      //   field: 'createdDate',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // },
      //
      // {
      //   headerName: 'Last Modified By',
      //   headerTooltip: 'Last Modified By',
      //   tooltipValueGetter: (params) =>
      //     'Last Modified By : ' + params.value,
      //   field: 'lastModifiedBy',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // },
      // {
      //   headerName: 'Last Modified Date',
      //   headerTooltip: 'Last Modified Date',
      //   tooltipValueGetter: (params) =>
      //     'Last Modified Date: ' + params.value,
      //   field: 'lastModifiedDate',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // },
    ];
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.paginationPageSize = 10;

    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");



  }
  //excel export function
  download() {

    this.gridAPI.exportDataAsCsv();

  }


  //excel export function
  onBtExport() {

    this.gridAPI.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridAPI) {

      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1

      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1

      this.totalPages = this.gridAPI.paginationGetTotalPages()

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

    this.gridAPI.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    this.gridAPI.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridAPI.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridAPI.paginationGoToLastPage();

  }

  // below function is to load the ag grid
  onGridReady(params) {
    this.onGridReadyParams = params
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.spinner.start()
    this.dataLoadService.reteriveIncrementalExtractionHistory().subscribe(res=>
    {
      if (res.error) {

        this.snackbar.open(res.statusMessage, "Ok", {
          duration: 5000
        });
        this.spinner.stop();
      } else {


        this.gridAPI.setGridOption('rowData', res);
        this.spinner.stop();

      }


    })

  }


  /**
   * @author Ravi G
   * @Date 23-01-2023
   * @Desc  popup for schedule time for start incr data load  and  insert custom
   * report template history and incremental extraction history
   */

  incrementalDataLoadSchedule() {
    this.dialog.open(IncrementalDataLoadSchedulePopupComponent, {
      width: "80%",
      autoFocus: false,
      data: { edata:undefined,scheduleFor:'Incremental Data'},

      disableClose: true,

    });


  }
  refresh(){
    this.onGridReady(this.onGridReadyParams)
  }


  s3FilePath
  downloadExtractionLog(e) {

    this.s3FilePath = e.rowData.extractionlog

    if (this.s3FilePath === undefined || this.s3FilePath === "" || this.s3FilePath === null) {

      this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    } else {
      let fileName = this.s3FilePath.split('/').pop()
      let data = {
        s3Path: this.s3FilePath,
      };
      this.spinner.start();
      this.etlService.downloadFileFromS3(data).subscribe(x => {
        this.spinner.stop()
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData) {
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else {
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
          setTimeout(function() {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }

      })

      this.spinner.stop();
    }
  }
}
